import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, Briefcase, Building2 } from 'lucide-react';
import http from '../api/http';
import { useFiliale } from '../context/FilialeContext';
import BlueHeader from '../components/BlueHeader';

const Activites = () => {
  const navigate = useNavigate();
  const { filialeId, isConsolidated } = useFiliale();
  const [activites, setActivites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchActivites();
  }, [filialeId, isConsolidated]);

  const fetchActivites = async () => {
    try {
      setLoading(true);
      const params = {};
      if (!isConsolidated && filialeId && filialeId !== 'all') {
        params.filiale_id = filialeId;
      }

      const response = await http.get('/api/activites', { params });
      setActivites(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('Erreur récupération activités:', error);
      setActivites([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-lg text-gray-500">Chargement...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <BlueHeader
        title="Mode de Paiement"
        subtitle="Sélectionnez une activité pour configurer les modes de paiement"
      />

      <div className="px-6 py-8">
        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
          <div className="px-6 py-4 border-b border-gray-200">
            <h3 className="text-lg font-semibold text-gray-800">Activités</h3>
            <p className="text-sm text-gray-500 mt-1">Cliquez sur une activité pour accéder à la configuration des modes de paiement</p>
          </div>

          {activites.length === 0 ? (
            <div className="px-6 py-12 text-center text-gray-500">
              Aucune activité trouvée
            </div>
          ) : (
            <div className="divide-y divide-gray-200">
              {activites.map((activite) => (
                <div
                  key={activite.idactivites}
                  onClick={() => navigate(`/types-personnel/${activite.idactivites}`)}
                  className="px-6 py-4 hover:bg-gray-50 cursor-pointer transition-colors flex items-center justify-between"
                >
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-full bg-purple-100 flex items-center justify-center">
                      <Briefcase className="h-6 w-6 text-purple-600" />
                    </div>
                    <div>
                      <h4 className="font-medium text-gray-900">{activite.Libelle_activite}</h4>
                      <p className="text-sm text-gray-500">ID: {activite.idactivites}</p>
                    </div>
                  </div>
                  <ChevronRight className="h-5 w-5 text-gray-400" />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Activites;
